module.exports = __webpack_public_path__ + "img/demonology.205d0247.jpg";